import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import Button from '../../../../components/Button'
import {purchaseStep} from '../../constants'
import SuccessFooter from '../purchaseLightBox/successStep/SuccessFooter'

export default class SwitchToFreeLightBoxFooter extends TemplateView {
    constructor({
        onOkButtonClick = () => {},
        onCancelButtonClick = () => {},
    } = {}) {
        super()

        this.params = {
            onOkButtonClick,
            onCancelButtonClick,
        }

        this.state = {
            purchaseStep: '',

            documentUrls: {
                serviceAgreementUrl: null,
                dataProcessingAgreementUrl: null,
                serviceAgreementExhibitUrl: null,
                invoiceUrl: null,
            }
        }

        this.onAnyStatePropertyChanged(['purchaseStep', 'documentUrls'], () => {
            this.$switchToFree.toggle(this.state.purchaseStep === purchaseStep.SWITCH_TO_FREE)
            const hasDocuments = Object.values(this.state.documentUrls).some((url) => !!url)
            this.$success.toggle(this.state.purchaseStep === purchaseStep.SUCCESS && hasDocuments)
        })
    }

    templateHtml() {
        return '<div class="switchToFreeFooter">' +
               '    <div class="switchToFree">' +
               '        <div class="okButtonContainer"/>' +
               '        <div class="cancelButtonContainer"/>' +
               '    </div>' +
               '    <div class="success"/>' +
               '</div>'
    }

    afterRender() {
        this.$switchToFree = this.find('.switchToFree')
        this.$success = this.find('.success')

        this.okButton = new Button({
            additionalClass: 'okButton',
            label: messageResource.getMessage('licenses.switch_to_free.ok'),
            onClickCb: this.params.onOkButtonClick,
        }).init(this.find('.okButtonContainer'))

        this.cancelButton = new Button({
            additionalClass: 'cancelButton',
            label: messageResource.getMessage('common.cancel'),
            onClickCb: this.params.onCancelButtonClick,
        }).init(this.find('.cancelButtonContainer'))

        new SuccessFooter().init(this.$success)
    }

    //for compatibility with LightBox
    getCommitBtnEl() {
        return []
    }

    //for compatibility with LightBox
    getCancelBtnEl() {
        return []
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/switchToFreeLightBox/SwitchToFreeLightBoxFooter.js